export const getCurrentURL = () => {
    const { href } = window.location;
    if (href.endsWith('/')) {
        return href.slice(0, -1);
    }
    return href;
};
